// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_aj-0";
export var orangeButton = "_aj-1";